import { KeycloakUser } from "../../../services/keycloak-service";
import { Match } from "../../../types/entities/match";
import { UUID } from "../../../types/uuid";

export function userIsSharable(
  user: KeycloakUser,
  match: Match,
  sharedUsers: UUID[],
  potentiallySharedUsers: UUID[]
): boolean {
  return (
    match !== null &&
    !userInArray(user.id, sharedUsers) &&
    !userInArray(user.id, potentiallySharedUsers) &&
    !matchCreatedBy(user.id, match)
  );
}

export function matchCreatedBy(user: string, match: Match): boolean {
  return match?.createdBy?.value === user;
}

export function userInArray(userId: string, sharedUsers: UUID[]): boolean {
  return !!sharedUsers?.find((id) => id.value === userId);
}
